/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Notifications_Filterbydeal3Inputs */

const en_coinvestments_notifications_filterbydeal3 = /** @type {(inputs: Coinvestments_Notifications_Filterbydeal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by deal`)
};

/**
* | output |
* | --- |
* | "Filter by deal" |
*
* @param {Coinvestments_Notifications_Filterbydeal3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_notifications_filterbydeal3 = /** @type {((inputs?: Coinvestments_Notifications_Filterbydeal3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Notifications_Filterbydeal3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_notifications_filterbydeal3(inputs)
});
export { coinvestments_notifications_filterbydeal3 as "coInvestments_notifications_filterByDeal" }